import { Box } from "@material-ui/core";
import { useFormikContext } from "formik";
import React, { CSSProperties, useMemo } from "react";
import { FormButton, FormButtonProps } from "ui/componentes/FormButton";
import { green } from "@material-ui/core/colors";

interface SubmitButtonProps {
    greenColor?: boolean;
}

const SubmitButton: React.FC<FormButtonProps & SubmitButtonProps> = ({
    children,
    greenColor = false,
    style,
    ...restProps
}) => {
    const { isSubmitting, dirty, values } = useFormikContext<any>();
    const newStyle = useMemo(() => {
        const newStyle: CSSProperties = { ...style };
        if (greenColor) {
            newStyle.backgroundColor = green["500"];
        }
        return newStyle;
    }, [style, greenColor]);
    const label = useMemo(() => {
        if (values?.id) {
            return "Atualizar";
        }
        return "Salvar";
    }, [values]);

    return (
        <Box position="relative">
            <FormButton
                color="primary"
                style={newStyle}
                type="submit"
                disabled={!dirty}
                {...restProps}
                loading={isSubmitting}
            >
                {children || label}
                {dirty && " *"}
            </FormButton>
        </Box>
    );
};

export { SubmitButton };
